import { render, staticRenderFns } from "./CaseLogic.vue?vue&type=template&id=453a7932&scoped=true&"
import script from "./CaseLogic.vue?vue&type=script&lang=js&"
export * from "./CaseLogic.vue?vue&type=script&lang=js&"
import style0 from "./CaseLogic.vue?vue&type=style&index=0&id=453a7932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a7932",
  null
  
)

export default component.exports